import Box from '@mui/material/Box';
import { useT } from '@transifex/react';
import React from 'react';
import { injectIntl } from 'react-intl';
import { SocialIcons } from './icons';
import messages from './messages';
import * as S from './styles';
const SocialMedia = React.memo(({ icons, heading, hideHeading = false }) => {
    const t = useT();
    return (React.createElement(Box, null,
        !hideHeading && React.createElement(S.Heading, null, heading || t(messages.title)),
        React.createElement(S.Container, null, icons.length &&
            icons.map((icon) => icon.iconUrl ? (React.createElement(S.Icon, { key: icon.uid, href: icon === null || icon === void 0 ? void 0 : icon.link, target: "_blank", rel: "noreferrer noopener" }, SocialIcons[icon.account])) : null))));
});
SocialMedia.displayName = 'SocialMedia';
export default injectIntl(SocialMedia);
//# sourceMappingURL=index.js.map